import { Component } from '@verndale/core';
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination, Controller } from 'swiper/modules';
import 'swiper/css/bundle';
import '../../scss/modules/_recommended-for-you.scss';

class RecommendedSlider extends Component {
  public recommendedSwiper: { slideTo?: (index: number) => void | undefined };

  constructor(el: HTMLElement) {
    super(el);
    this.recommendedSwiper = {};
    this.initSwiper();
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      swiperContainer: this.el.querySelector<HTMLElement>('.swiper'),
      swiperWrapper: this.el.querySelector<HTMLElement>('.swiper-wrapper'),
      swiperItems: this.el.querySelectorAll<HTMLElement>('.recommended-card'),
      nextArrow: this.el.querySelector<HTMLElement>('.swiper-button-next'),
      prevArrow: this.el.querySelector<HTMLElement>('.swiper-button-prev')
    };

    this.initSwiper();
  }

  initSwiper() {
    Swiper.use([Navigation, Keyboard, Pagination, Controller]);

    if ((this.dom.swiperItems && (this.dom.swiperItems as NodeList).length > 4) || window.matchMedia('(max-width: 768px)').matches) {
      this.recommendedSwiper = new Swiper(this.dom.swiperContainer as HTMLElement, {
        navigation: {
          nextEl: this.dom.nextArrow as HTMLElement,
          prevEl: this.dom.prevArrow as HTMLElement
        },
        breakpoints: {
          320: {
            slidesPerView: 1.1,
            spaceBetween: 16
          },
          768: {
            slidesPerView: 3.7,
            spaceBetween: 24
          }
        },
        preventClicksPropagation: true,
        preventInteractionOnTransition: true,
      });
    } else {
      (this.dom.nextArrow as HTMLElement)?.classList.add('hidden');
      (this.dom.prevArrow as HTMLElement)?.classList.add('hidden');
      (this.dom.swiperWrapper as HTMLElement)?.classList.add('no-swiper');
    }
  }
}

export default RecommendedSlider;
